<template>
    <dt
        :class="classObject"
        data-spec-class="description-list-title"
    >
        <slot />
    </dt>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue';
import { Theme } from '@/types';

interface Props {
    theme?: Theme;
}

const props = withDefaults(defineProps<Props>(), {
    theme: Theme.Normal,
});

const classObject = computed(() => ({
    'mb-3': true,
    'text-base text-tertiary ': props.theme === Theme.Normal,
    'text-xl text-secondary font-bold': props.theme === Theme.Primary,
}));
</script>
